import React, { Component } from 'react';


export default class BaseComponent extends Component {

}


// WEBPACK FOOTER //
// ./src/common/script/components/BaseComponent.js